import Icon from './icon';

export * from './icon';
export * from './iconSet';

export default Icon;
